import { Map, Placemark, YMaps, ZoomControl } from "react-yandex-maps"

export const Schema = () => {
    return (<section className="shema plr">
        <div className="wmain">
            <div className="tm">Схема проезда</div>
            <div className="shema_content">
                    <YMaps>
						<div id="map" style={{ width: "100%", height: "100%" }}>
							<Map defaultState={{ center: [44.123332, 43.452445], zoom: 16, controls: [] }} style={{ width: "100%", height: "100%", position: "relative" }}  >
								<ZoomControl options={{ float: 'left' }} />
								<Placemark geometry={[44.123604, 43.452162]}
									options={{
										iconLayout: 'default#image',
										hideIconOnBalloonOpen: false,
										iconImageSize: [123, 53],
										iconImageOffset: [-37, -73],
										cursor: 'default',
										iconShadow: true,
										balloonclose: true,
										iconImageHref: 'img/logo-olymp.svg',
										balloonPanelMaxMapArea: 0,
									}}
								/>

							</Map>
						</div>
					</YMaps>
            </div>
            <div className="shema_bottom_text">
                Возможность быстрого выезда на Пятигорск
            </div>
        </div>
    </section>
    )
}

export default Schema